"use client";

import { useEffect, useRef } from "react";
import type { FaqPage } from "./events";
import { track } from "./track";

/** Fires `faq_opened` on each closed → open transition of an FAQ panel (including mounting open). */
export function useTrackFaqOpened(page: FaqPage, isOpen: boolean): void {
    const wasOpen = useRef(false);

    useEffect(() => {
        if (isOpen && !wasOpen.current) track("faq_opened", { page });
        wasOpen.current = isOpen;
    }, [isOpen, page]);
}
